import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import NProgress from 'nprogress'
import store from '../store'

// 重写vue-router的push, 新版本push方法会返回一个promise, 如果没有捕获异常，控制台会报错 Uncaught (in promise) undefined
// 参见 https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

NProgress.configure({ showSpinner: true })

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const whiteList = ['login']
const defaultRoutePath = '/'

router.beforeEach((to, from, next) => {
  NProgress.start()
  store.commit('system/CLEAR_TOKEN') // 取消请求
  const Token = Vue.ls.get('Token')
  if (Token) {
    if (to.path === '/Login') {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      const redirect = decodeURIComponent(from.query.redirect || to.path)
      if (redirect.includes(to.path)) {
        // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
        // next({ ...to, replace: true })
        next()
      } else {
        // 跳转到目的路由
        next({ path: redirect })
      }
      // next()
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({
        path: '/Login',
        query: { redirect: to.fullPath }
      })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach((to, from) => {
  const { meta: { title } } = to
  window.document.title = `pms-${title}`
  NProgress.done()
})

export default router
